import * as jwt_decode from 'jwt-decode';
export function isAdmCheck() {
  try {
    const token = localStorage.getItem('id_token');
    if (token) {
      const decoded = jwt_decode(token);
      if (decoded && decoded.role) {
        localStorage.setItem('role', decoded.role);
        return localStorage.getItem("role") === "ADMIN" ? true : false;
      }
    }
    return false;
  }
  catch {
    return false;
  }
}
